export default __webpack_public_path__ + "static/media/MOTIVO_16.c018e928.jpg";